import { Link } from 'react-router-dom';
import { faBadgeCheck as faBadgeCheckLine } from '@fortawesome/pro-regular-svg-icons';
import { faBadgeCheck as faBadgeCheckSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProfileItemTriggerKeys } from 'components/profile-panel/PanelPopoverButtons';
import * as Tooltip from 'components/tooltip';
import { AnchorHashIds } from 'constants/anchor-hash-ids';
import { posthogEvents } from 'constants/posthog-events';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { usePosthog } from 'customHooks/usePosthog';
import { twMerge } from 'tailwind-merge';

const ProfileVerificationIcon = () => {
    const { isAccountSponsoredOrVerified } = useCurrentAccount();
    const { accountId } = useCurrentAccount();
    const { pushEvent } = usePosthog();
    return (
        <Tooltip.Root>
            <Tooltip.Trigger
                className={isAccountSponsoredOrVerified ? 'cursor-default' : 'cursor-pointer'}
            >
                {isAccountSponsoredOrVerified ? (
                    <ProfileVerificationIconDisplay />
                ) : (
                    <Link
                        to={`/accounts/${accountId}/settings/about/verify#${AnchorHashIds.VerifyNonprofit}`}
                        onClick={() =>
                            pushEvent(posthogEvents.DASHBOARD_PROFILE_ITEM_SELECTED, {
                                profileItem: ProfileItemTriggerKeys.VerificationIcon,
                            })
                        }
                    >
                        <ProfileVerificationIconDisplay />
                    </Link>
                )}
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse>
                    <Tooltip.Arrow inverse />
                    <p className="max-w-52 text-xs/5 font-medium">
                        {isAccountSponsoredOrVerified
                            ? 'Verified nonprofit'
                            : 'Unlock benefits like additional payment options and shorter transaction pending periods when you’re verified'}
                    </p>
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

const ProfileVerificationIconDisplay = () => {
    const { isAccountSponsoredOrVerified } = useCurrentAccount();
    return (
        <p
            className={twMerge(
                'flex w-fit items-center gap-1 rounded-full px-2 py-1 text-xs font-medium',
                isAccountSponsoredOrVerified
                    ? 'text-brand-cobalt-primary bg-blue-50'
                    : 'text-warning-700 bg-warning-50',
            )}
        >
            <FontAwesomeIcon
                icon={isAccountSponsoredOrVerified ? faBadgeCheckSolid : faBadgeCheckLine}
            />
            {isAccountSponsoredOrVerified ? 'Verified' : 'Unverified'}
        </p>
    );
};

export { ProfileVerificationIconDisplay, ProfileVerificationIcon };
